class CountdownTimer {
  constructor(element) {
    this.element = element;
    this.textElement = element.querySelector('.countdown-section__timer-text');

    // Get configuration from data attributes
    this.endDate = element.getAttribute('data-end-date');
    this.endTime = element.getAttribute('data-end-time');
    this.daysLabel = element.getAttribute('data-days-label') || 'T';
    this.hoursLabel = element.getAttribute('data-hours-label') || 'S';
    this.minutesLabel = element.getAttribute('data-minutes-label') || 'M';
    this.secondsLabel = element.getAttribute('data-seconds-label') || 'S';

    // Parse the end date and time
    this.targetDate = this.parseTargetDate();

    // Start the countdown
    if (this.targetDate) {
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }
  }

  parseTargetDate() {
    try {
      // Combine date and time strings
      const dateTimeString = `${this.endDate}T${this.endTime}:00`;
      const date = new Date(dateTimeString);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        console.error('Invalid countdown date/time');
        return null;
      }

      return date;
    } catch (error) {
      console.error('Error parsing countdown date:', error);
      return null;
    }
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.targetDate.getTime() - now;

    // If countdown is finished
    if (distance < 0) {
      this.textElement.textContent = `00${this.daysLabel}. 00${this.hoursLabel}. 00${this.minutesLabel}. 00${this.secondsLabel}.`;
      clearInterval(this.interval);
      return;
    }

    // Calculate time units
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Format with leading zeros
    const formattedDays = String(days).padStart(2, '0');
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    // Update the display
    this.textElement.textContent = `${formattedDays}${this.daysLabel}. ${formattedHours}${this.hoursLabel}. ${formattedMinutes}${this.minutesLabel}. ${formattedSeconds}${this.secondsLabel}.`;
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Initialize all countdown timers on the page
document.addEventListener('DOMContentLoaded', () => {
  const countdownElements = document.querySelectorAll('.countdown-section__timer');
  const timers = [];

  countdownElements.forEach(element => {
    timers.push(new CountdownTimer(element));
  });

  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    timers.forEach(timer => timer.destroy());
  });
});

// Support for Shopify theme editor
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const countdownElement = event.target.querySelector('.countdown-section__timer');
    if (countdownElement) {
      new CountdownTimer(countdownElement);
    }
  });
}
